module.exports = __webpack_public_path__ + "202203fc2588b1008a7349b19f0fd521.jpg";